module.exports = __webpack_public_path__ + "img/Picto_Form_01.8aebc089.svg";